import Player from '@vimeo/player';

export default class Video {
    
    static get selector() {
        return '.homeIntro__video';
    }

    constructor(el) {
        this.isActive = false;
        this.el = el;
        this.link = this.el.querySelector('.homeIntro__videoLink');
        this.id = this.link.getAttribute('data-video-id');
        this.setEvents();
    }

    init() {
        if(!this.isActive) {
            this.isActive = true;
            this.createContainer();

            this.player = new Player(this.playerElement, {
                id: this.id,
                width: window.innerWidth,
                playsinline: false,
                autoplay: true,
                color: '1A5A82',
                title: false
            });

            this.player.on('loaded', () => {
                this.lightbox.classList.remove('videoLightbox--loading');
                this.lightbox.classList.add('videoLightbox--active');
                //this.player.play();
            })
        }
    }


    createContainer() {
        this.lightbox = document.createElement('div');
        this.lightbox.classList.add('videoLightbox');
        this.lightbox.classList.add('videoLightbox--loading');
        this.lightbox.addEventListener('click', this.e_close.bind(this));


        document.addEventListener("keydown", (e) => {
            if(e.which == 27) this.e_close();
        })

        this.playerContainer = document.createElement('div');
        this.playerContainer.classList.add('videoLightbox__container');

        this.playerPreContainer = document.createElement('div');
        this.playerPreContainer.classList.add('videoLightbox__precontainer');

        this.lightboxClose = document.createElement('button');
        this.lightboxClose.innerText = 'Close';
        this.lightboxClose.classList.add('videoLightbox__close');
        this.lightboxClose.addEventListener('click', this.e_close.bind(this));
        this.playerContainer.appendChild(this.lightboxClose);


        this.playerElement = document.createElement('div');
        this.playerElement.classList.add('videoLightbox__player');
        this.playerContainer.appendChild(this.playerElement);
        this.lightbox.appendChild(this.playerPreContainer);
        this.playerPreContainer.appendChild(this.playerContainer);

        document.body.appendChild(this.lightbox);
    }
    

    setEvents() {
        this.link.addEventListener('click', this.e_click.bind(this));
    }

    e_close(e) {
        this.player.pause();
        this.lightbox.classList.remove('videoLightbox--active');
        setTimeout(()=>{
            this.lightbox.parentElement.removeChild(this.lightbox);
            this.isActive = false;
        }, 600);
    }

    e_click(e) {
        e.preventDefault();
        this.init();
    }



}